import React from 'react'
import MenuItem from '@material-ui/core/MenuItem'
import i18next from 'i18next'
import { scrollToTarget } from './scrollTo'
import { salaryModel } from './openForWork.utils'

const alvList = [
  {
    alv: 24,
    description:
      '24% Pääsääntöisesti työsuoritteet laskutetaan tällä verokannalla'
  },
  {
    alv: 10,
    description: '10% Kulttuuri- ja viihdetilaisuuksien lipunmyynti (AVL 85a§)'
  },
  { alv: 10, description: '10% Taide-esineen myynti (AVL 85a§)' },
  {
    alv: 10,
    description: '10% Liikunnanohjausta yksityisasiakkaalle (AVL 85a§)'
  },
  { alv: 0, description: '0% Rakennusalan käänteinen alv (AVL 8c§)' },
  { alv: 0, description: '0% Taiteilijan palkkio (AVL 45§)' },
  {
    alv: 0,
    description: '0% Terveyden- ja sairaanhoitopalvelu (AVL 34§ 1. mom)'
  },
  { alv: 0, description: '0% Koulutetun hierojan palvelu (AVL 34§ 1. mom)' },
  { alv: 0, description: '0% Sosiaalialan työ (AVL 37§)' },
  { alv: 0, description: '0% Opetustyö valtiolle (AVL 39§)' },
  { alv: 0, description: '0% Viittomakielen tulkkaus (AVL 59§ 5. mom)' },
  { alv: 0, description: '0% Vakuutuspalvelujen myynti (AVL 44§)' },
  {
    alv: 0,
    description:
      '0% Toisessa EU-maassa sijaitseva yritys/yhdistys, jolla on voimassa oleva VAT-ID tunnus (AVL 44§)'
  },
  { alv: 0, description: '0% Euroopan unioni (EU dir. 2006/112/EY, 151 art.)' },
  {
    alv: 0,
    description: '0% Euroopan unionin ulkopuolinen laskutus (AVL 44§)'
  },
  { alv: 0, description: '0% Kansainvälinen laivatyö (AVL 71§)' }
]
const titleList = [
  'KONSULTTI',
  'OHJELMISTOSUUNNITTELIJA',
  'ART DIRECTOR',
  'AGRONOMI'
]
const countryList = [
  'Norja',
  'Venäjä',
  'Viro',
  'Saksa',
  'Islanti',
  'Suomi',
  'Ruotsi',
  'Tanska'
]

const invoiceStateList = [
  'Luonnos',
  'Lähetetty',
  'Maksettu',
  'Erääntynyt',
  'Alimaksettu',
  'Ylimaksettu'
]

const unitList = ['kpl', 'h']
const alvPercentageList = [
  { alv: 0, description: '0 %' },
  { alv: 10, description: '10 %' },
  { alv: 14, description: '14 %' },
  { alv: 24, description: '24 %' },
  { alv: 25.5, description: '25,5 %' }
]

const costTypeList = [
  { value: 'travel tickets', label: 'newExpenc.costType1', id: 1001 },
  { value: 'taxi costs', label: 'newExpenc.costType2', id: 1002 },
  { value: 'accommodation expenses', label: 'newExpenc.costType3', id: 1003 },
  { value: 'parking fees', label: 'newExpenc.costType4', id: 1004 },
  { value: 'other expenses', label: 'newExpenc.costType5', id: 1005 }
]

export const createMenuItems = (menuItems) => {
  return menuItems.map((item, index) => (
    <MenuItem key={index} value={item}>
      {item}
    </MenuItem>
  ))
}

export const createVehicleItems = (vehicleItems) =>
  vehicleItems.map((el, index) => (
    <MenuItem key={index} value={el.type}>
      {el.value}
    </MenuItem>
  ))

export const countryItems = createMenuItems(countryList)

export const alvPercentageItems = alvPercentageList.map((item, index) => (
  <MenuItem key={index} value={item.alv}>
    {item.description}
  </MenuItem>
))

export const costTypeItems = (t) => {
  return costTypeList.map((item) => (
    <MenuItem key={item.id} value={item.value}>
      {t(item.label)}
    </MenuItem>
  ))
}

export const unitItems = createMenuItems(unitList)
export const titleItems = createMenuItems(titleList)
export const alvItems = alvList.map((item, index) => (
  <MenuItem key={index} value={item.alv}>
    {item.description}
  </MenuItem>
))

export const invoiceStateListItems = createMenuItems(invoiceStateList)

export const convertStateToInt = (state) => {
  switch (state) {
    case 'Luonnos':
      return 0
    case 'Lähetetty':
      return 1
    case 'Maksettu':
      return 2
    case 'Käsittelyssä':
      return 3
    case 'Hylätty':
      return 4
    case 'Rahoitettu':
      return 5
    case 'Ei nostettu': //oldcase 'Ylimaksettu'
      return 6
    case 'Epäselvä': //oldcase 'Alimaksettu'
      return 7
    case 'Ei Hyväksytty':
      return 8
    case 'Perinnässä':
      return 9
    case 'Reklamoitu':
      return 10
    case 'Keskeytetty':
      return 11
    case 'P Hylätty':
      return 12
    case 'Muokattu':
      return 13
    case 'Osittain maksu':
      return 15
    case 'Admin Lähetetty':
      return 17
    case 'Admin Maksettu':
      return 18
    case 'Admin Osittain maksu':
      return 19
    case 'Admin Hylätty':
      return 20
    case 'Admin Luonnos':
      return 21
    case 'Muokattu Luonnos':
      return 22
    case 'Admin Perinnässä':
      return 23
    case 'Maksettu (MP)':
      return 24
  }
}

export const convertIntToState = (state, location) => {
  switch (state) {
    case 0:
      return i18next.t('names.luo') //'Luonnos'
    case 1:
      return i18next.t('names.lahe') //'Lähetetty'
    case 2:
      return i18next.t('names.maks') //'Maksettu'
    case 3:
      return i18next.t('names.kasi') //'Käsittelyssä'
    case 4:
      return i18next.t('names.hyla') //'Hylätty'
    case 5:
      return i18next.t('names.rahoi') //'Rahoitettu'
    case 6:
      return i18next.t('names.noste') //'Ei nostettu'
    case 7:
    case 15:
      return i18next.t('names.osit') //'Epäselvä', 'Osittain maksu'
    case 8:
      return i18next.t('names.hyvak') //'Ei Hyväksytty'
    case 9:
      return i18next.t('names.peri') //'Perinnässä'
    case 10:
      return i18next.t('names.rek') // Reklamoitu
    case 11:
      return i18next.t('names.kes') // Keskeytetty
    case 12:
      return i18next.t('names.phyla') // P Hylätty
    case 13:
      return i18next.t('names.muk') // Muokattu
    case 17:
      return i18next.t('names.adminSent') // Admin Lähetetty
    case 18:
      return i18next.t('names.adminPaid') // Admin Maksettu
    case 19:
      return i18next.t('names.adminPartialPaid') // Admin Osittain maksu
    case 20:
      return i18next.t('names.adminRejected') // Admin Hylätty
    case 21:
      return i18next.t('names.adminDrafted') // Admin Luonnos
    case 22:
      return i18next.t('names.MuokattuLuonnos') // Modified Draft
    case 23:
      return i18next.t('names.AdminPerinnässä') // Admin Perinnässä
    case 24:
      return location === 'userView'
        ? i18next.t('names.maks') // Maksettu
        : i18next.t('names.muistutusPoistettu') // Maksettu (MP)
    case 40:
      return i18next.t('names.lahetetaan')
    case 44:
      return i18next.t('names.lahetysEpaonnistui')
  }
}

export const convertNameToState = (state) => {
  switch (state) {
    case 'processing':
      return i18next.t('names.kasi') //'Käsittelyssä'
    case 'paid':
      return i18next.t('names.maks') //'Maksettu'
    case 'rejected':
      return i18next.t('names.hyla') //'Hylätty'
    case 'bankingprocess':
      return i18next.t('names.pankki') //'Pankin käsittelyssä'
    case 'bankreject':
      return i18next.t('names.pankkiReject') //'Pankki hylännyt'
    case 'bankaccept':
      return i18next.t('names.pankkiAccept') //'Pankki hyväksynyt'
    case 'Pplasku':
      return i18next.t('names.Pplasku') //'QuickPay Invoice'
    case 'IRValid':
      return i18next.t('names.irvalid') //'IR accepted'
    case 'IRRejected':
      return i18next.t('names.irrejected') //'IR rejected'
    case 'IRCancelled':
      return i18next.t('names.ircancelled') //'cancelled the salary report'
    case 'IRRejectCancelled':
      return i18next.t('names.irrejectcancelled') //'cancellation of  the salary report rejected by IR'
    case 'IRManual':
      return i18next.t('names.irmanualinen') //enter the salary into IR through procounter
    case 'BankingInitiation':
      return i18next.t('names.pankiinit')
    case 'IRinitiated':
      return i18next.t('names.irinit')
    case 'qp_processing':
      return i18next.t('names.Ppkasi') //'PpKäsittelyssä'
    default:
      return ''
  }
}

export const nestProperties = (obj, property, nestedProperties) => {
  var newObj = {}
  var nestedObj = {}
  var nestedArr = []

  for (var i = 0; i < nestedProperties.length; ++i) {
    if (nestedProperties[i] in obj) {
      nestedObj[nestedProperties[i]] = obj[nestedProperties[i]]
    }
  }

  for (var k in obj) {
    if (!(k in nestedObj)) {
      newObj[k] = obj[k]
    }
  }

  nestedArr[0] = nestedObj

  newObj[property] = nestedArr

  return newObj
}

export const mergePaidInvoices = (data) => {
  // Clone the array to avoid modifying the original
  const mergedData = [...data]

  const paidIndex = mergedData.findIndex((item) => item.status === 'Paid')
  const paidMPIndex = mergedData.findIndex(
    (item) => item.status === 'Paid (MP)'
  )

  // If both "Paid" and "Paid (MP)" exist, merge their counts
  if (paidIndex !== -1 && paidMPIndex !== -1) {
    mergedData[paidIndex].invoicecount += mergedData[paidMPIndex].invoicecount

    // Remove "Paid (MP)" from the array
    mergedData.splice(paidMPIndex, 1)
  }

  return mergedData
}

export const propertyArray = (array, key) => {
  let list = []
  for (var i = 0; i < array.length; i++) {
    list.push(array[i][key])
  }
  return list
}

/* export const propClubArray = (array, key1, key2) => {
  let list = []
  for (var i = 0; i < array.length; i++) {
    list.push(`${array[i][key1]} ${array[i][key2]}%`)
  }
  return list
} */

export const nestPropertyAsObject = (obj, property, nestedProperties) => {
  var newObj = {}
  var nestedObj = {}

  for (var i = 0; i < nestedProperties.length; ++i) {
    if (nestedProperties[i] in obj) {
      nestedObj[nestedProperties[i]] = obj[nestedProperties[i]]
    }
  }

  for (var k in obj) {
    if (!(k in nestedObj)) {
      newObj[k] = obj[k]
    }
  }

  newObj[property] = nestedObj
  return newObj
}

export const reverseDate = (dateString) => {
  return (
    dateString.substr(8, 2) +
    '.' +
    dateString.substr(5, 2) +
    '.' +
    dateString.substr(0, 4)
  )
}

export const isValidGroup = (array) => {
  let b = true
  if (array[0] == 'bankaccept') {
    for (let i = 1; i < array.length; i++) {
      if (array[i] !== array[0]) {
        b = false
        break
      } else b = true
    }
    return b
  } else if (array[0] == 'bankreject') {
    for (let i = 1; i < array.length; i++) {
      if (array[i] === array[0]) {
        b = true
      } else if (
        array[i] !== array[0] &&
        array[i] === 'processing' &&
        array[i] !== 'IRRejected' &&
        array[i] != 'IRValid'
      ) {
        b = true
      } else {
        b = false
        break
      }
    }
    return b
  } else if (array[0] == 'processing') {
    for (let i = 1; i < array.length; i++) {
      if (array[i] === array[0]) {
        b = true
      } else if (
        array[i] !== array[0] &&
        array[i] === 'bankreject' &&
        array[i] !== 'IRRejected' &&
        array[i] != 'IRValid'
      ) {
        b = true
      } else {
        b = false
        break
      }
    }
    return b
  } else if (array[0] == 'bankingprocess') {
    for (let i = 1; i < array.length; i++) {
      if (array[i] === array[0]) {
        b = true
      } else {
        b = false
        break
      }
    }
    return b
  } else if (
    array[0] == 'IRRejected' ||
    array[0] == 'paid' ||
    array[0] == 'IRCancelled'
  ) {
    for (let i = 1; i < array.length; i++) {
      if (
        array[i] !== 'IRRejected' &&
        array[i] !== 'paid' &&
        array[i] !== 'IRCancelled'
      ) {
        b = false
        break
      } else b = true
    }
    return b
  } else if (array[0] == 'IRValid' || array[0] == 'IRRejectCancelled') {
    for (let i = 1; i < array.length; i++) {
      if (array[i] !== 'IRValid' && array[i] !== 'IRRejectCancelled') {
        b = false
        break
      } else b = true
    }
    return b
  }
  return b
}

export const compareDatesToLogic = (
  due_date,
  logic,
  remindersent,
  customer_type
) => {
  let due_date_to_logic
  if (logic === 'recover') {
    if (due_date == null) {
      let new_due_date
      due_date = new Date()
      new_due_date = new Date()
      new_due_date.setDate(new Date(due_date).getDate() - 2)
      due_date_to_logic = new Date(new_due_date)
    } else {
      let new_reminder_due_date
      new_reminder_due_date = new Date(due_date)
      if (customer_type == 'company') {
        new_reminder_due_date.setDate(new_reminder_due_date.getDate() + 7)
      } else {
        new_reminder_due_date.setDate(new_reminder_due_date.getDate() + 14)
      }
      due_date_to_logic = new Date(new_reminder_due_date)
    }
  } else {
    due_date_to_logic = new Date(due_date)
    if (customer_type == 'company') {
      due_date_to_logic.setDate(due_date_to_logic.getDate() + 5)
    } else {
      due_date_to_logic.setDate(due_date_to_logic.getDate() + 14)
    }
  }

  due_date_to_logic.setHours(0, 0, 0, 0)

  let current_date = new Date()
  current_date.setHours(0, 0, 0, 0)

  //Weekends Reminder/Debt Collection Icon gets inactive
  if (due_date_to_logic < current_date) {
    const day1 = current_date.getDay()
    if ((day1 === 0 || day1 === 6) && remindersent === 0) return false
    else return true
  } else {
    return false
  }
}

export const scrollToInvoiceForm = () => {
  scrollToTarget('invoice-info-scroll-section', -120)
}

export const scrollIntoView = (id) => {
  const section = document.getElementById(id)
  section.scrollIntoView({ behavior: 'smooth' })
}

export const calculateTotalSum = (
  totalIncludesVat,
  quantity,
  quantityPrice,
  vatPercent,
  isExpense,
  isAllowance
) => {
  if (isNaN(quantity) || isNaN(quantityPrice) || isNaN(vatPercent)) return 0
  const sum =
    Math.round(
      ((totalIncludesVat && !isExpense && !isAllowance
        ? quantity * quantityPrice.toString().replace(/,/g, '.')
        : quantity *
          quantityPrice.toString().replace(/,/g, '.') *
          (1 + vatPercent / 100)) +
        Number.EPSILON) *
        100
    ) / 100
  return sum
}

export const calculateTaxFreeSum = (
  shouldDeductVat,
  quantity,
  quantityPrice,
  vatPercent,
  isExpense,
  isAllowance
) => {
  if (isNaN(quantity) || isNaN(quantityPrice) || isNaN(vatPercent)) return 0
  const sum =
    Math.round(
      ((shouldDeductVat && !isExpense && !isAllowance
        ? (quantity * quantityPrice.toString().replace(/,/g, '.')) /
          (1 + vatPercent / 100)
        : quantity * quantityPrice.toString().replace(/,/g, '.')) +
        Number.EPSILON) *
        100
    ) / 100
  return sum
}

export const calculateVat = (
  quantity,
  quantityPrice,
  vatPercent,
  priceInludesVat,
  isExpense,
  isAllowance
) => {
  if (isNaN(quantity) || isNaN(quantityPrice) || isNaN(vatPercent)) return 0
  let vat =
    priceInludesVat && !isExpense && !isAllowance
      ? Math.round(
          ((quantityPrice * quantity) / (1 + 100 / vatPercent) +
            Number.EPSILON) *
            100
        ) / 100
      : Math.round(
          (quantityPrice * quantity * (vatPercent / 100) + Number.EPSILON) * 100
        ) / 100
  return vat
}

export const renderAlvPercentageItems = (shouldDisableVat0, isInvoiceItem) => {
  return alvPercentageList.map((item, index) => {
    return (
      <MenuItem
        key={index}
        value={item.alv}
        disabled={item.alv === 0 && shouldDisableVat0 && isInvoiceItem}
      >
        {item.description}
      </MenuItem>
    )
  })
}

export const findDuplicateFieldIndexes = (array, field) => {
  const fieldsMap = {}
  const duplicateIndexes = []

  array.forEach((item, index) => {
    if (item[field] !== undefined && item[field] !== '') {
      if (fieldsMap[item[field]] !== undefined) {
        duplicateIndexes.push(index)
      } else {
        fieldsMap[item[field]] = index
      }
    }
  })

  return duplicateIndexes
}

// Format values to send draft invoice after light entrepreneur signs assignment - Open for work
export const invoiceValues = (
  invoiceFormDefaultValues,
  invoiceRowDefaultValues,
  assignmentOffered
) => {
  const amount = assignmentOffered?.amount?.toString().replace(',', '.')
  const agreementId = assignmentOffered?.agreement_id ?? null
  const workshift_itemid = assignmentOffered?.workshift_itemid ?? null
  // invoice rows values
  const invoiceRows = { ...invoiceRowDefaultValues }
  invoiceRows.description =
    assignmentOffered?.job_title !== 'N/A'
      ? assignmentOffered?.job_title
      : 'Assignment is directly offered by the employer.'
  invoiceRows.start_date = new Date(assignmentOffered?.assignment_begins)
  invoiceRows.end_date = new Date(
    assignmentOffered?.assignment_ends || assignmentOffered?.assignment_begins
  )
  invoiceRows.quantity =
    assignmentOffered?.salary_model === 'Hourly rate' ||
    (assignmentOffered?.salary_model === 'Commission' &&
      assignmentOffered?.time_spent !== undefined) // Work shift
      ? assignmentOffered?.time_spent
      : 1
  invoiceRows.unit = salaryModel(assignmentOffered?.salary_model)
  invoiceRows.quantity_price = amount
  invoiceRows.sum_tax_free = calculateTaxFreeSum(
    true,
    invoiceRows.quantity,
    invoiceRows.quantity_price,
    25.5,
    false,
    false
  )
  invoiceRows.sum_with_vat = calculateTotalSum(
    true,
    invoiceRows.quantity,
    invoiceRows.quantity_price,
    25.5,
    false,
    false
  )

  // invoice values
  const invoiceValues = { ...invoiceFormDefaultValues }
  invoiceValues.agreementId = agreementId
  invoiceValues.workshift_itemid = workshift_itemid
  invoiceValues.billing_date = new Date(invoiceValues.billing_date)
  invoiceValues.due_date = new Date(invoiceValues.due_date)
  invoiceValues.company_name = assignmentOffered?.company_name
  invoiceValues.business_id = assignmentOffered?.business_id
  invoiceValues.person_to_contact = assignmentOffered?.contact_name
  invoiceValues.person_to_quick_pay_email = ''
  invoiceValues.person_to_contact_email = assignmentOffered?.email
  invoiceValues.delivery_address = assignmentOffered?.address
  invoiceValues.zip_code = assignmentOffered?.zip_code
  invoiceValues.city = assignmentOffered?.city
  invoiceValues.invoice_price_selection = true
  invoiceValues.rows = [invoiceRows]
  invoiceValues.sum = calculateTaxFreeSum(
    true,
    invoiceRows.quantity,
    amount,
    25.5,
    false,
    false
  )
  invoiceValues.total_sum = calculateTotalSum(
    true,
    invoiceRows.quantity,
    amount,
    25.5,
    false,
    false
  )
  // calculate vat
  invoiceValues.vat = 0
  invoiceValues.rows.forEach((row) => {
    row.vat = calculateVat(
      parseFloat(row.quantity),
      parseFloat(row.quantity_price),
      row.vat_percent,
      true,
      false, // isExpense
      false // isAllowance
    )
    invoiceValues.vat += row.vat
  })

  const newinvoiceValues = { ...invoiceValues }

  delete newinvoiceValues.customer_id

  return newinvoiceValues
}

export const getInvoiceStatusStyle = (status, due_date) => {
  const isOverDue =
    status === 1 && formatDate(new Date()) > formatDate(new Date(due_date))

  let style = {
    display: 'inline-block',
    padding: '6px 12px',
    borderRadius: '10px',
    color: 'white',
    backgroundColor: 'green'
  }

  if (isOverDue) {
    return { ...style, backgroundColor: '#d30303' } // red
  } else if (status === 2 || status === 24) {
    return { ...style, backgroundColor: 'green' } // green
  } else if (status === 1) {
    return { ...style, backgroundColor: '#6049de' } // blue purple
  } else {
    return {}
  }
}

export const formatDate = (item) => {
  const date = new Date(item).setHours(0, 0, 0, 0)
  return new Date(date)
}
